import React, { useState, useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import AuthProvider from "./context/AuthContext";
import InstallPWA from "./components/InstallPWA";
import { setupForegroundNotification } from "./notifications/foregroundNotification";

// Google OAuth and UI imports
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CircularProgress, Box, Typography } from "@mui/material";
import API from "./api/api"; // Make sure this path to your Axios config is correct

function App() {
  const [clientId, setClientId] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setupForegroundNotification();

    const handleAddressChange = () => { };
    window.addEventListener("storage", handleAddressChange);

    // ✅ Fetch the Google Client ID from FastAPI
    const fetchClientId = async () => {
      try {
        const res = await API.get("/config/google-client-id");
        setClientId(res.data.client_id.trim());
      } catch (err) {
        console.error("Failed to fetch Google Client ID from backend", err);
        setError(true);
      }
    };

    fetchClientId();

    return () => {
      window.removeEventListener("storage", handleAddressChange);
    };
  }, []);

  // Show error if backend is unreachable
  if (error) {
    return (
      <Box sx={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center', bgcolor: '#f8f8f8', textAlign: 'center', p: 3 }}>
        <Typography color="error">
          Failed to load application configuration. Please check your connection.
        </Typography>
      </Box>
    );
  }

  // Hold rendering until the Client ID arrives
  if (!clientId) {
    return (
      <Box sx={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center', bgcolor: '#f8f8f8' }}>
        <CircularProgress sx={{ color: '#FF4B2B' }} />
      </Box>
    );
  }

  return (
    // ✅ Dynamically inject the fetched Client ID
    <GoogleOAuthProvider clientId={clientId}>
      <AuthProvider>
        <InstallPWA />
        <AppRoutes />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;